import { Component, Ref, Watch } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import { humanStorageSize, downloadFile } from '@/utils/index'
import dayjs from 'dayjs'
import './index.less'
import { downloadGET } from '@/api/api'
import { FirmwareServiceProxy } from '@/service-proxies/app-v2/console.service-proxies'
import { MasterlinkTenantServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { FirmwareServiceProxy as FirmwareService } from '@/service-proxies/app-v2/iot-console.service-proxies'
import CurdForm from '@/components/BaseCurd/form'
import UploadModal from './components/UploadModal'
import PushModal from './components/PushModal'

const firmwareService = new FirmwareServiceProxy()
const tenantService = new MasterlinkTenantServiceProxy()
const fsp = new FirmwareService()

@Component({
  CurdForm,
  UploadModal,
  PushModal
})
export default class Firmware extends Template {
  @Ref() readonly form: CurdForm

  acl = {
    create: 'page_firmware_management_upload',
    update: 'page_firmware_management_push_title',
    delete: 'page_firmware_management_delete',
    download: 'page_firmware_management_download'
  }
  scroll = {}
  uploadModalVisible = false
  pushModalVisible = false
  tenantList: any = []
  tenantId: string = ''
  fileName: string = '' // 搜索关键词:固件名称
  waitGetData = true

  get options() {
    if (~this.$route.path.indexOf('edge-data')) {
      return {
        retrieve: firmwareService.getFirmwares.bind(firmwareService),
        create: (data) => {

        },
        update: (data) => {

        },
        delete: firmwareService.deleteFirmwares.bind(firmwareService),
      }
    } else if (~this.$route.path.indexOf('iot-console')) {
      return {
        retrieve: fsp.pageFirmware.bind(fsp),
        create: (data) => {

        },
        update: (data) => {

        },
        delete: fsp.deleteFirmwares.bind(fsp),
      }
    }
  }

  get version() {
    if (~this.$route.path.indexOf('edge-data')) {
      return 'old'
    } else if (~this.$route.path.indexOf('iot-console')) {
      return 'new'
    }
  }

  get columns() {
    return [
      {
        title: this.$t('page_batch_management_action'),
        key: 'action',
        fixed: 'left',
        width: 200,
        customRender: (row, record) => {
          return (
            record.size &&
            <div>
              <a
                type="link"
                v-acl={this.getAcl(this.acl.download)}
                onClick={() => {
                  this.download(record)
                }}
              >
                {this.$t('page_my_document_download')}
              </a>
              <a-divider type="vertical"/>
              <a-popconfirm title={this.$t('page_resource_pool_confirm_delete')}
                            onConfirm={() => {
                              this.delete(record.id)
                            }}
                            okText={this.$t('yes')}
                            cancelText={this.$t('no')}
              >
                <a class="del-color" v-acl={this.getAcl(this.acl.delete)}>{this.$t('delete')}</a>
              </a-popconfirm>
            </div>
          )
        }
      },
      {
        title: this.$t('page_firmware_management_name'),
        dataIndex: 'fileName',
        key: 'fileName',
        width: 350,
        ellipsis: true
      },
      {
        title: this.$t('page_firmware_management_size'),
        dataIndex: 'size',
        key: 'size',
        width: 250,
        customRender: (text) => {
          if(text) {
            return (humanStorageSize(text))
          }
        }
      }, {
        title: this.$t('page_firmware_management_upload_time'),
        dataIndex: 'createTime',
        key: 'createTime',
        customRender: (time,record) => {
          if(time) {
            return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
          }
        }
      }
    ]
  }

  get lang() {
    return {
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      create: this.$t('page_firmware_management_upload'),
      delete: this.$t('delete'),
      update: this.$t('page_firmware_management_push_title'),
      download: this.$t('page_firmware_management_download')
    }
  }

  get extraTenantsList() {
    /*const tempArr = [{
          id: '0',
          tenantCode: this.$t('page_firmware_management_all_tenant'),
          tenantId: '0'
        }, ...this.tenantList]*/
    return this.tenantList.map(item => ({ label: item.tenantCode, value: item.tenantId }))
  }

  async created() {
    // 获取租户列表
    try {
      const res = await tenantService.getTenants('', 1, -1, '', '')
      this.tenantList = res.data.records
      let tenantId = this.tenantList && this.tenantList.length ? this.tenantList[0].tenantId : ''
      this.handleTenantChange(tenantId)
    } catch (e) {
      console.log(e)
    }
  }

  async getData(
    current = this.filters.current,
    size = this.filters.size,
    fileName = this.fileName,
    tenantId = this.tenantId
  ) {
    if (this.fileName) current = 1
    const fetchFn = this.options.retrieve
    if (this.version === 'old') {
      let { items, total: t, size: s, current: c } = await fetchFn(
        current,
        fileName,
        size,
        tenantId,
        ''
      )
      // this.dataSource = items

      let dataLength = items.length;
      let copy = JSON.parse(JSON.stringify(items));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      } 

      this.dataSource =  JSON.parse(JSON.stringify(copy));
      console.log(this.dataSource,'aa')   

      this.filters = {
        total: Number(t),
        size: Number(s),
        current: Number(c)
      }
    } else {
      let { items, totalCount: t } = await fetchFn(
        {
          ascs: '',
          current: current,
          descs: '',
          fileName: fileName,
          filter: '',
          size: size,
          tenantId: tenantId,
          version: ''
        }
      )
      // this.dataSource = items

      let dataLength = items.length;
      let copy = JSON.parse(JSON.stringify(items));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      } 

      this.dataSource =  JSON.parse(JSON.stringify(copy));
      console.log(this.dataSource,'aa') 

      this.filters.total = Number(t)
    }

  }

  async delete(id) {
    if (this.version === 'old') {
      this.deleteSingleData([id])
    } else {
      this.deleteSingleData({
        firmwareIdList: [id]
      })
    }
  }

  async download(record) {
    const { fileId, fileName } = record
    downloadGET(null, fileId).then((res: any) => { downloadFile(res, fileName) })
  }

  headerEle() {
    return (
      <div
        slot="action"
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <a-button v-acl={this.acl.create} type="primary" style={{ marginRight: '8px' }}
                    onClick={this.openUploadModal}>
            {this.lang.create}
          </a-button>

          <a-button v-acl={this.acl.update} style={{ marginRight: '8px' }} onClick={() => this.pushModalVisible = true}>
            {this.lang.update}
          </a-button>

          <a-popconfirm title={this.$t('page_resource_pool_confirm_delete')}
                        onConfirm={this.deleteData}
                        okText={this.$t('yes')}
                        cancelText={this.$t('no')}
                        disabled={this.selectedIds.length < 1}
          >
            <a-button v-acl={this.acl.delete} type="danger" disabled={this.selectedIds.length < 1}>
              {this.lang.delete}
            </a-button>
          </a-popconfirm>
        </div>

        <div style="display: flex;">
          <app-select list={this.extraTenantsList} v-model={this.tenantId} onChangeSelect={this.handleTenantChange} style="min-width: 200px;"/>
          <a-input-search placeholder={this.lang.placeholder} enterButton={this.lang.search} allowClear={true}
                          onSearch={this.onSearch}/>
        </div>
      </div>
    )
  }

  async deleteData() {
    const fetchFn = this.options.delete

    const { current } = this.filters
    const restDataLength = this.dataSource.length - this.selectedIds.length
    if (this.version === 'old') {
      await fetchFn(this.selectedIds)
    } else {
      await fetchFn({ firmwareIdList: this.selectedIds })
    }
    this.selectedIds = []
    this.$message.success(this.$t('page_user_management_delete_succeeded'))
    await this.getData(
      !restDataLength ? (current - 1 ? current - 1 : current) : current
    )
    this.showDrawer = false
  }

  handleTenantChange(value) {
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.tenantId = value
    this.getData()
  }

  onSearch(value) {
    this.getData(1, 15, value)
  }

  openUploadModal() {
    this.uploadModalVisible = true
  }

  closeUploadModal(data) {
    this.uploadModalVisible = false
    if (data) {
      this.getData()
    }
  }

  closePushModal(data) {
    this.pushModalVisible = false
    if (data) {

    }
  }

  render() {
    return (
      <blank-view class="firmware-wrapper">
        {this.headerEle()}
        <div style="height:100%">
          {this.renderBody()}
          <UploadModal class="upload-modal" visible={this.uploadModalVisible} tenantList={this.tenantList}
                       version={this.version} onClose={this.closeUploadModal}/>
          <PushModal class="push-modal" visible={this.pushModalVisible} tenantList={this.tenantList}
                     version={this.version} onClose={this.closePushModal}/>
        </div>
      </blank-view>
    )
  }
}
